import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import AgenteIaFarmacia from "@/pages/AgenteIaFarmacia";

export const Route = createFileRoute("/agente-ia-farmacia")({
  head: () => buildHead({
    title: "Agente de IA para Farmácia: atenda e venda no WhatsApp 24h",
    description: "Agente de IA que atende clientes, registra pedidos, agenda entregas e faz recompra de uso contínuo na sua farmácia, 24h no WhatsApp e no Instagram. CRM incluso.",
    path: "/agente-ia-farmacia",
  }),
  component: AgenteIaFarmacia,
});
